import instance from "../axios";

export const getRatio = async (params = {}) => {
  const queryParams = {};

  if (typeof params.smdId !== "undefined") queryParams.smdId = String(params.smdId);
  if (typeof params.provinceId !== "undefined") queryParams.provinceId = String(params.provinceId);
  if (typeof params.cityId !== "undefined") queryParams.cityId = String(params.cityId);

  const response = await instance.get(`stockRatio`, { params: queryParams });
  return response.data;
}

export const getCoverage = async (params = {}, range) => {
    const queryParams = {};

  if (typeof params.smdId !== "undefined") queryParams.smdId = String(params.smdId);
  if (typeof params.provinceId !== "undefined") queryParams.provinceId = String(params.provinceId);
  if (typeof params.cityId !== "undefined") queryParams.cityId = String(params.cityId);
  if (typeof params.index !== "undefined") queryParams.index = String(params.index);
    const response = await instance.get(`stockRatio/stores`, { params : queryParams })
    return response.data
}